import React, { Fragment, useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { isEmpty } from 'ramda'

import {
  Typography,
  Button,
  Row,
  Col,
  List,
  Modal,
  Tooltip,
  message,
} from 'antd'

const { Title, Text } = Typography

import './index.less'
import { PIN_IFRAME_URI } from '../../../config'

import api from 'services/api'
import copy from '/public/img/copy_icon.svg'

export const Codes = ({ fetchedProducts, accessToken, pin }) => {
  const [products, setProducts] = useState([])

  const [isSubmitting, setSubmitting] = useState(false)

  const [clickedBtn, setClickedBtn] = useState([])

  const [modalState, setModalState] = useState({
    visibleModal: false,
    clickedCopyBtn: false,
    hoveredCopyBtn: false,
    hoveredCardNumber: false,
    hoveredCode: false,
  })

  const [activeItem, setActiveItem] = useState({
    contentType: '',
    activeItemContent: '',
    activeItemTutorial: '',
    activeItemName: '',
  })

  useEffect(() => {
    let products = []
    fetchedProducts.map((product, index) => {
      products.push({ id: index + 1, name: product })
      setProducts(products)
    })
  }, [])

  const copyToClipboard = () => {
    let textArea = document.createElement('textArea')
    textArea.value = document.getElementById('code').innerHTML
    document.body.appendChild(textArea)
    textArea.select()
    textArea.setSelectionRange(0, 99999)
    document.execCommand('copy')
    textArea.remove()
  }

  const openModalWithItem = async (id, productName) => {
    setSubmitting(true)
    setModalState({ ...modalState, visibleModal: true })

    try {
      const { data } = await api.get(
        `/delivery-bundle/${pin}/products/${id}?accessToken=${accessToken}`,
      )

      if (data.errors) {
        message.error(
          'Não foi possível processar a requisição. Por favor, tente novamente em alguns minutos',
        )
      } else if (data.content) {
        setClickedBtn(clickedBtn => [...clickedBtn, id])

        setModalState({
          ...modalState,
          visibleModal: true,
        })

        setActiveItem({
          contentType: data.type,
          activeItemContent: data.content,
          activeItemName: productName,
          activeItemTutorial: data.tutorialUrl,
          activeItemTutorialDescription: data.tutorialDescription,
          activeItemAutomaticRedeemUrl: data.automaticRedeemUrl,
        })
      } else {
        message.error(
          'Ocorreu um erro interno. Favor entrar em contato com o suporte',
        )
      }
    } catch (error) {
      message.error(
        'Ocorreu um erro interno. Por favor, tente novamente em alguns minutos',
      )
    }

    setSubmitting(false)
  }

  const closeModal = () => {
    setModalState({
      ...modalState,
      visibleModal: false,
    })
  }

  const handleHoverChange = hovered => {
    setModalState({
      ...modalState,
      hoveredCopyBtn: hovered,
      clickedCopyBtn: false,
      hoveredCardNumber: false,
    })
  }

  const handleClickChange = clicked => {
    setModalState({
      ...modalState,
      clickedCopyBtn: clicked,
      hoveredCopyBtn: false,
      hoveredCardNumber: false,
    })
  }

  const handleVisible = (clicked, type) => {
    setModalState({
      ...modalState,
      clickedCopyBtn: false,
      hoveredCopyBtn: false,
      hoveredCode: type === 'hoveredCode' ? clicked : false,
      hoveredCardNumber: type === 'hoveredCardNumber' ? clicked : false,
      hoveredPassword: type === 'hoveredPassword' ? clicked : false,
    })
  }

  const returnModalContent = () => {
    const helpSection = (
      <Text style={{ display: 'block', marginTop: 20 }}>
        {activeItem.activeItemTutorialDescription
          ? activeItem.activeItemTutorialDescription
          : 'Tem problemas? Veja o nosso tutorial'}
        <a
          href={activeItem.activeItemTutorial}
          target='_blank'
          rel='noopener noreferrer'
          style={{ color: 'rgba(0, 0, 0, 0.65)' }}
        >
          <strong> Clique aqui</strong>
        </a>
      </Text>
    )

    if (activeItem.contentType === 'plain') {
      let codeInfo = activeItem.activeItemAutomaticRedeemUrl ? (
        <div>
          <a
            href={activeItem.activeItemAutomaticRedeemUrl.replace(
              '$code',
              activeItem.activeItemContent,
            )}
            target='_blank'
            rel='noopener noreferrer'
          >
            <Text id='code' className='code'>
              {activeItem.activeItemContent}
            </Text>
          </a>
        </div>
      ) : (
        <Text id='code' className='code'>
          {activeItem.activeItemContent}
        </Text>
      )

      if (activeItem?.activeItemContent.includes(':')) {
        const codeItems = activeItem.activeItemContent.split(':')

        codeInfo = (
          <div className='container-items'>
            {codeItems.length > 0 && !isEmpty(codeItems[0]) && (
              <p>
                <Tooltip
                  visible={modalState.hoveredCardNumber}
                  onVisibleChange={clicked =>
                    handleVisible(clicked, 'hoveredCardNumber')
                  }
                  placement='topRight'
                  title='O número do cartão é usado para identificar o código a ser resgatado caso ocorra algum problema, guarde-o para eventual consulta.'
                >
                  <Text className='label'>Número do Cartão: </Text>
                </Tooltip>
                <br />
                <Text className='code'>{codeItems[0]}</Text>
              </p>
            )}

            {codeItems.length > 1 && !isEmpty(codeItems[1]) && (
              <p>
                <Tooltip
                  visible={modalState.hoveredCode}
                  onVisibleChange={clicked =>
                    handleVisible(clicked, 'hoveredCode')
                  }
                  placement='topRight'
                  title='Código de resgate que só poderá ser utilizado uma vez.'
                >
                  <Text className='label'>Código de Resgate: </Text>
                </Tooltip>
                <br />
                {/* For items that have automatic redeem url, use link registered on the category */}
                {activeItem.activeItemAutomaticRedeemUrl ? (
                  <a
                    href={activeItem.activeItemAutomaticRedeemUrl.replace(
                      '$code',
                      codeItems[1],
                    )}
                    target='_blank'
                    rel='noopener noreferrer'
                  >
                    <Text id='code' className='code'>
                      {codeItems[1]}
                    </Text>
                  </a>
                ) : (
                  <Text id='code' className='code'>
                    {codeItems[1]}
                  </Text>
                )}
              </p>
            )}

            {codeItems.length > 3 && !isEmpty(codeItems[3]) && (
              <p>
                <Text className='label'>VSN: </Text>

                <br />
                <Text id='code' className='code'>
                  {codeItems[3]}
                </Text>
              </p>
            )}

            {codeItems.length > 2 && !isEmpty(codeItems[2]) && (
              <p>
                <Tooltip
                  visible={modalState.hoveredPassword}
                  onVisibleChange={clicked =>
                    handleVisible(clicked, 'hoveredPassword')
                  }
                  placement='topRight'
                  title='Senha para resgatar o código.'
                >
                  <Text className='label'>Senha de Resgate: </Text>
                </Tooltip>
                <br />
                <Text id='code' className='code'>
                  {codeItems[2]}
                </Text>
              </p>
            )}
          </div>
        )
      }

      return (
        <div>
          <div
            id='modal-item-div'
            style={{ justifyContent: 'center', minHeight: '50px' }}
          >
            {codeInfo}
            <Tooltip
              visible={modalState.hoveredCopyBtn}
              onVisibleChange={handleHoverChange}
              placement='topRight'
              title='Copiar Código'
            >
              <Tooltip
                trigger='click'
                placement='topRight'
                title='Código Copiado'
                visible={modalState.clickedCopyBtn}
                onVisibleChange={handleClickChange}
              >
                <Button
                  shape='circle'
                  size='large'
                  onClick={copyToClipboard}
                  style={{ position: 'absolute', right: '40px' }}
                >
                  <img src={copy} />
                </Button>
              </Tooltip>
            </Tooltip>
          </div>
          {activeItem.activeItemTutorial && helpSection}
        </div>
      )
    } else if (activeItem.contentType === 'uri') {
      const content = activeItem.activeItemContent
      const isHypeProduct = activeItem.activeItemContent.match(PIN_IFRAME_URI)
      const iframeSrc = isHypeProduct
        ? PIN_IFRAME_URI + '/widget/pin/' + content.split('/').pop()
        : content

      return (
        <div>
          <div id='iframe-wrapper'>
            <iframe id='iframe-content' src={iframeSrc}></iframe>
          </div>

          {activeItem.activeItemTutorial && helpSection}
        </div>
      )
    } else if (activeItem.contentType === 'image') {
      return (
        <div>
          <div id='image-content-div'>
            <img
              id='img-content'
              src={`data:image/gif;base64,${activeItem.activeItemContent}`}
            />
          </div>
          {activeItem.activeItemTutorial && helpSection}
        </div>
      )
    }
  }

  return (
    <Fragment>
      <Row
        style={{
          height: '100%',
          overflow: 'auto',
        }}
      >
        <Col
          xs={{ span: 20, offset: 2 }}
          lg={{ span: 13, offset: 7 }}
          xl={{ offset: 7 }}
          xxl={{ offset: 6 }}
          id='div-list'
        >
          <Text style={{ fontSize: 20 }}>Aqui estão seus produtos</Text>
          <List
            id='list-items'
            dataSource={products}
            renderItem={item => (
              <List.Item id='item'>
                <Col xs={16} style={{ display: 'inline-block' }}>
                  <Col xs={4}>
                    <Text id='item-index'>{item.id}</Text>
                  </Col>

                  <Col xs={20}>
                    <Title level={4} id='item-name'>
                      {item.name}
                    </Title>
                  </Col>
                </Col>
                <Col xs={8}>
                  <Button
                    type='primary'
                    id={
                      clickedBtn.includes(item.id)
                        ? 'clicked-btn'
                        : 'show-modal-btn'
                    }
                    onClick={() => openModalWithItem(item.id, item.name)}
                    loading={isSubmitting}
                    style={{ fontSize: 14 }}
                  >
                    Pegue o PIN
                  </Button>
                </Col>
              </List.Item>
            )}
          />
        </Col>
      </Row>
      <Modal
        visible={modalState.visibleModal}
        onOk={closeModal}
        onCancel={closeModal}
        closable
        centered
        footer={null}
        style={{ textAlign: 'center' }}
        id='modal'
      >
        <Text
          style={{
            fontSize: 20,
          }}
        >
          {(activeItem.contentType === 'plain' ||
            activeItem.contentType === 'image') && (
            <div id='modal-title'>
              Seu código para <strong>{activeItem.activeItemName}</strong> é:
            </div>
          )}
        </Text>
        {returnModalContent()}
      </Modal>
    </Fragment>
  )
}

Codes.propTypes = {
  /** PIN codes to be rendered to the customer */
  codes: PropTypes.array,

  /** Product names to be rendered to the customer */
  fetchedProducts: PropTypes.array,

  /** Delivery bundle pin */
  pin: PropTypes.string,

  /** Validated access token */
  accessToken: PropTypes.string,
}
